/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 服薬状況種別
 */
export type MedicationStatusTypeEnum =
  (typeof MedicationStatusTypeEnum)[keyof typeof MedicationStatusTypeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MedicationStatusTypeEnum = {
  PRESCRIPTION: 'PRESCRIPTION',
  OTC: 'OTC',
  UNKNOWN: 'UNKNOWN',
} as const;
